<div class="flex-layout right-side user-icon" *ngIf="usersList != undefined && usersList > 0 ">
    <ng-container *ngFor="let imageUrl of  imageList.slice(0, 3);">
        <div class="user-images" *ngIf="imageUrl != null">
            <ng-container>
                <img *ngIf="imageUrl.profilepicture != null  && imageUrl.profilepicture != ''; else defaultProfile" class="avatar-image" src="{{imageUrl.profilepicture}}" placement="bottom" tooltip="{{imageUrl.username}}"
                     [container]="isGridCell ? 'body' : null">
                <ng-template #defaultProfile>
                    <img placement="bottom" tooltip="{{imageUrl.username}}" [container]="isGridCell ? 'body' : null" src="images/profile_avatar_small.jpg" alt="Avatar" class="avatar-image">
                </ng-template>
            </ng-container>
        </div>
    </ng-container>
    <span class="image-count" *ngIf="usersList > 3" [tooltip]="HtmlContent" [container]="isGridCell ? 'body' : null" placement="bottom">+{{(usersList)-3}}</span>
</div>
<ng-template #HtmlContent>
    <div class="img-position">
        <ul class="assignee-container content-icon-align"
            *ngFor="let assignee of imageList">
            <li>
                <img
                    *ngIf="assignee.profilepicture != null  && assignee.profilepicture != ''; else defaultProfile"
                    src="{{assignee.profilepicture}}" alt="Avatar"
                    class="tooltip-profile-radius img-width avatar-user-icon-size">
                <ng-template #defaultProfile>
                    <img src="images/profile_avatar_small.jpg" alt="Avatar"
                         class="tooltip-profile-radius img-width">
                </ng-template>
                <span class="assignee-name-alignment">{{assignee.username}}</span> &nbsp;

            </li>
        </ul>
    </div>
</ng-template>
